module.exports = __webpack_public_path__ + "graphics/09.ckh.8a01b56d56b70a1cec4218d5e7109e76.png";